import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-verhuizen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVerhuizen {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M6.97 13c0 1.1.9 2 2 2s2-.9 2-2v-1h-4z"/>
  <path d="m35.81 17.6-2.07-4.44A2.005 2.005 0 0 0 31.92 12h-3.94V7c0-1.1-.9-2-2-2H2a2 2 0 0 0-2 2v19c0 1.1.9 2 2 2h1.01c-.02.17-.05.33-.05.5 0 2.48 2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5c0-.17-.03-.33-.05-.5h12.11c-.02.17-.05.33-.05.5 0 2.48 2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5c0-.17-.03-.33-.05-.5h1.05c1.1 0 2-.9 2-2v-7.56c0-.29-.06-.58-.19-.84ZM7.47 31a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m5.51-18c0 1.86-1.28 3.41-3 3.86V19h2c.55 0 1 .45 1 1s-.45 1-1 1H5.97c-.55 0-1-.45-1-1s.45-1 1-1h2v-2.14c-1.72-.45-3-2-3-3.86v-2c0-.55.45-1 1-1h6.01c.55 0 1 .45 1 1zm9.64 1.89c-.39.39-1.02.39-1.42 0l-1.22-1.21v6.33c0 .55-.45 1-1 1s-1-.45-1-1v-6.3l-1.19 1.19c-.39.39-1.02.39-1.42 0a.996.996 0 0 1 0-1.41l2.91-2.91c.39-.39 1.02-.39 1.42 0l2.91 2.91c.39.39.39 1.02 0 1.41ZM28.5 31a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m5.51-12H28v-5h4l2 4v1Z"/>
</svg>

    );
  }
}
